import React, { useEffect, useRef, useState } from "react";
import { deleteFile, uploadFile } from "@/api/placeOffer";

import { BsCheckCircleFill } from "react-icons/bs";
import { businessFileds, buyerFields } from "../offer/cif/formFields";
import DynamicForm from "../offer/cif/DynamicForm";
import ContinueConfirmationModal from "./ContinueConfirmationModal";
import { validateAddress } from "@/api/bid";
import { ShimmerText } from "react-shimmer-effects";

const EditBuyer = ({
  state,
  setAccordionState,
  accordionState,
  editCifData,
  setEditCifData,
  validateEmail,
  llc,
  cifId,
  documents,
}) => {
  const [purchaseforIndividual, setPurchaseForIndividual] = useState("true");
  const [cobuyer, setCobuyer] = useState("false");
  const [isCoBuyerBusiness, setIsCoBuyerBusiness] = useState("false");
  const [buyer, setBuyer] = useState({});
  const [cobuyerDetails, setCobuyerDetails] = useState({});
  const [documentLoading, setDocumentLoading] = useState(false);
  const [haveErrors, setHaveErrors] = useState(false);
  const [externalFormErrors, setExternalFormErrors] = useState({});
  const [externalFormErrorsCo, setExternalFormErrorsCo] = useState({});
  const [fileErrors, setFileErrors] = useState({
    "llc-upload": "",
    "co-buyer": "",
  });
  const [uploadedFiles, setUploadedFiles] = useState({
    businessEntityDocs: [],
    coBuyerBusinessDocs: [],
  });
  const validationFnRef = useRef({
    buyer: null,
    coBuyer: null,
  });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const MAX_FILE_SIZE = 10 * 1024 * 1024;
    const ACCEPTED_FILE_TYPES =  [
  "application/pdf",
  "image/jpeg",
  "image/jpg"
];

  const handleClose = () => setShow(false);
  useEffect(() => {
    if(state?.buyer?.company){
      setPurchaseForIndividual("false")

    }else{
      setPurchaseForIndividual("true")
    }
    setBuyer({
      ...buyer,
      firstName: state?.buyer?.firstName || "",
      lastName: state?.buyer?.lastName || "",
      middleInitials: state?.buyer?.middleInitials || "",
      email: state?.buyer?.email || "",
      phone: state?.buyer?.phone || "",
      address1: state?.buyer?.address1 || "",
      address2: state?.buyer?.address2 || "",
      city: state?.buyer?.city || "",
      stateId: state?.buyer?.stateId || "",
      zip: state?.buyer?.zip || "",
      company:state?.buyer?.company || ""
    });
    if(state?.coBuyer){
      setCobuyer("true")
      if(state?.coBuyer?.company){
        setIsCoBuyerBusiness("true")
      }else{
        setIsCoBuyerBusiness("false")
      }
      
      setCobuyerDetails({
      ...cobuyerDetails,
      firstName: state?.coBuyer?.firstName || "",
      lastName: state?.coBuyer?.lastName || "",
      middleInitials: state?.coBuyer?.middleInitials || "",
      email: state?.coBuyer?.email || "",
      phone: state?.coBuyer?.phone || "",
      address1: state?.coBuyer?.address1 || "",
      address2: state?.coBuyer?.address2 || "",
      city: state?.coBuyer?.city || "",
      stateId: state?.coBuyer?.stateId || "",
      zip: state?.coBuyer?.zip || "",
      company:state?.coBuyer?.company || ""
    });
    }else{
      setCobuyerDetails({});

    }
  }, [state]);
  useEffect(() => {
    setBuyer((prev) => ({
      ...prev,
      purchaseFor: purchaseforIndividual === "true" ? "INDIVIDUAL" : "BUSINESS",
    }));
  }, [purchaseforIndividual]);

  useEffect(() => {
    if (documents?.coBuyerLLCFiles?.length > 0) {
      setUploadedFiles((prev) => ({
        ...prev,
        coBuyerBusinessDocs: [
          ...(prev["coBuyerBusinessDocs"] || []),
          ...documents?.coBuyerLLCFiles,
        ],
      }));
    }
    if (documents?.buyerLLCFiles?.length > 0) {
      setUploadedFiles((prev) => ({
        ...prev,
        businessEntityDocs: [
          ...(prev["businessEntityDocs"] || []),
          ...documents?.buyerLLCFiles,
        ],
      }));
    }
  }, [documents]);

  const checkStateCityZip = async (address1, city, stateId, zip, type) => {
    try {
      const payload = {
        address1: address1,
        city: city,
        state: stateId,
        zip: zip,
      };
      const data = await validateAddress(payload);
      if (data?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
        // setInvalidCombination(true);
        if (type === "buyer") {
          setExternalFormErrors((prev) => ({
            ...prev,
            zip: "Provided zip code is not valid for selected state",
          }));
        } else {
          setExternalFormErrorsCo((prev) => ({
            ...prev,
            zip: "Provided zip code is not valid for selected state",
          }));
        }
        setLoading(false);
        setHaveErrors(true);
        return { hasError: true };
      } else {
        if (type === "buyer") {
          setExternalFormErrors((prev) => {
            const { zip, ...rest } = prev;
            return rest;
          });
        } else {
          setExternalFormErrorsCo((prev) => {
            const { zip, ...rest } = prev;
            return rest;
          });
        }
        setLoading(false);
        return { hasError: false };
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "cobuyer") {
      setCobuyer(value);
    } else if (name === "cobuyerBusiness") {
      setIsCoBuyerBusiness(value);
    } else {
      setPurchaseForIndividual(value);
    }
  };
const handleFileUpload = async (event, fileType) => {
  setDocumentLoading(true);
  const file = event.target.files[0];
  const fieldName = event.target.name;

  setFileErrors((prev) => ({ ...prev, [fieldName]: "" }));

  if (!file) {
    setFileErrors((prev) => ({
      ...prev,
      [fieldName]: "Please select a file.",
    }));
    setDocumentLoading(false);
    return;
  }

  const isValidType = ACCEPTED_FILE_TYPES.includes(file.type);
  const isValidSize = file.size <= MAX_FILE_SIZE;

  if (!isValidType) {
    setFileErrors((prev) => ({
      ...prev,
      [fieldName]: `Please upload document in pdf, jpg or jpeg format.`,
    }));
    setDocumentLoading(false);
    return;
  }

  if (!isValidSize) {
    setFileErrors((prev) => ({
      ...prev,
      [fieldName]: "Maximum file size allowed is 10MB.",
    }));
    setDocumentLoading(false);
    return;
  }

  try {
    const formData = new FormData();
    const data = {
     listingId: state?.listingId,
      fileCategory: "LLC",
      fileSubCategory:
        fileType === "businessEntityDocs" ? "LLC-buyer" : "LLC-cobuyer",
      cifId,
    };

    formData.append("file", file);
    formData.append(
      "fileUploadRequest",
      new Blob([JSON.stringify(data)], {
        type: "application/json",
      })
    );

    const response = await uploadFile(formData);

    if (response?.data?.data) {
      setUploadedFiles((prev) => ({
        ...prev,
        [fileType]: [...(prev[fileType] || []), response.data.data],
      }));

      setFileErrors((prev) => ({
        ...prev,
        [fieldName]: "",
      }));
    } else {
      throw new Error("No data returned from upload API.");
    }
  } catch (error) {
    console.error("Upload failed:", error);
    setFileErrors((prev) => ({
      ...prev,
      [fieldName]: error?.message || "Error uploading file.",
    }));
  } finally {
    event.target.value = ""; // reset file input
    setDocumentLoading(false);
  }
};

  const handleFileDelete = async (fileType, fileId) => {
    try {
      setDocumentLoading(true);
      const listingId = state?.listingId;
      const data = await deleteFile({ fileId, listingId });
      if (data?.data?.status === "SUCCESS") {
        setBuyer((prevState) => {
          const newState = { ...prevState };
          delete newState[fileType];
          return newState;
        });
        setDocumentLoading(false);

        setUploadedFiles((prev) => ({
          ...prev,
          [fileType]: prev[fileType].filter(
            (file) => file.documentId !== fileId
          ),
        }));

        setFileErrors((prev) => ({
          ...prev,
          [fileType === "businessEntityDocs" ? "llc-upload" : "co-buyerllc"]:
            "",
        }));
      } else {
        setDocumentLoading(false);
        setFileErrors((prev) => ({
          ...prev,
          [fileType === "businessEntityDocs" ? "llc-upload" : "co-buyerllc"]:
            "Error deleting file",
        }));
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      setFileErrors((prev) => ({
        ...prev,
        [fileType === "businessEntityDocs" ? "llc-upload" : "co-buyerllc"]:
          "Error deleting file",
      }));
      setDocumentLoading(false);
    }
  };

  const handleFileDownload = async (documentId, fileName) => {
    try {
      const response = await fetch(
        `/portal/postcontract/download/${documentId}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error("File not found or access denied");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "download";
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const submitData = async () => {
    const buyerValidation = validationFnRef.current.buyer?.();
    const coBuyerValidation =
      cobuyer === "true"
        ? validationFnRef.current.coBuyer?.()
        : { isValid: true, errors: {} };

    const allErrors = {
      ...buyerValidation?.errors,
      ...coBuyerValidation?.errors,
    };
    if (
      uploadedFiles.businessEntityDocs?.length === 0 &&
      llc === "Required" &&
      purchaseforIndividual === "false"
    ) {
      setFileErrors((prev) => ({
        ...prev,
        "llc-upload": "Please upload at least one LLC document to proceed.",
      }));
      return;
    }

    if (
      cobuyer === "true" &&
      isCoBuyerBusiness === "true" &&
      uploadedFiles.coBuyerBusinessDocs?.length === 0 &&
      llc === "Required"
    ) {
      setFileErrors((prev) => ({
        ...prev,
        "co-buyerllc": "Please upload at least one LLC document to proceed.",
      }));
      return;
    }

    const allValid =
      (buyerValidation?.isValid ?? true) &&
      (coBuyerValidation?.isValid ?? true);

    if (!allValid) {
      return;
    }
    setLoading(true);
    const add = await checkStateCityZip(
      buyer?.address1,
      buyer?.city,
      buyer?.stateId,
      buyer?.zip,
      "buyer"
    );
    if (add.hasError) {
      return;
    }
    if (cobuyer === "true") {
      const coadd = await checkStateCityZip(
        cobuyerDetails?.address1,
        cobuyerDetails?.city,
        cobuyerDetails?.stateId,
        cobuyerDetails?.zip,
        "cobuyer"
      );
      if (coadd?.hasError) {
        return;
      }
    }
    if (allValid) {
      setShow(true);
    }
  };

  const findNextAccordion = () => {
    // need to check one scenario hence keeping this commented 
    // if (state?.representedByAgent !== "Y" || state?.representedByAgent!==null || state?.loggedInUserRole!=="BuyerAgent" ) {
    //   setAccordionState({
    //     ...accordionState,
    //     accordion1: {
    //       ...accordionState.accordion1,
    //       close: true,
    //       edit: true,
    //       visited: true,
    //     },
    //     accordion3: {
    //       ...accordionState.accordion3,
    //       close: false,
    //       edit: false,
    //       visited: false,
    //     },
    //     accordion4: {
    //       ...accordionState.accordion4,
    //       close: true,
    //       edit: false,
    //       visited: false,
    //     },
    //     accordion4: {
    //       ...accordionState.accordion4,
    //       close: true,
    //       edit: false,
    //       visited: false,
    //     },
    //   });
    // } else {
      setAccordionState({
        ...accordionState,
        accordion1: {
          ...accordionState.accordion1,
          close: true,
          edit: true,
          visited: true,
        },
        accordion2: {
          ...accordionState.accordion2,
          close: false,
          edit: false,
          visited: false,
        },
        accordion3: {
          ...accordionState.accordion3,
          close: true,
          edit: false,
          visited: false,
        },
        accordion4: {
          ...accordionState.accordion4,
          close: true,
          edit: false,
          visited: false,
        },
      });
    // }
  };
  const continueToAgent = () => {
      const updatedBuyer = {
    ...buyer,
    company: buyer?.purchaseFor === "INDIVIDUAL" ? "" : buyer?.company,
  };

  const updatedCoBuyer = cobuyer === "false" ? {} : {
    ...cobuyerDetails,
    company: isCoBuyerBusiness === "false" ? "" : cobuyerDetails?.company,
  };

  setEditCifData({
    ...editCifData,
    buyer: updatedBuyer,
    coBuyer: updatedCoBuyer,
  });

    // setEditCifData({
    //   ...editCifData,
    //   buyer: buyer,
    //   coBuyer: cobuyer==="false"?{}:cobuyerDetails,
    // });
    findNextAccordion();
    handleClose();
  };
  return (
    <>
      <div className="accordion-item mb-2 border rounded">
        <h2 className="accordion-header  p-1" id="flush-headingTwo">
          <div
            className={`accordion-button ${
              accordionState?.accordion1?.close ? "collapsed" : ""
            }  ${
              accordionState?.accordion1?.close &&
              accordionState?.accordion1?.visited
                ? "no-caret"
                : ""
            }`}
            id="acc2"
            disabled={accordionState?.accordion1?.close}
          >
            <div className="d-flex justify-content-between w-100">
              <p className="mb-0">
                {accordionState?.accordion1?.visited ? (
                  <BsCheckCircleFill className="icon_bid me-2" size={30} />
                ) : (
                  <BsCheckCircleFill className="text-dark me-2" size={30} />
                )}
                Buyer
              </p>
              {accordionState?.accordion1?.edit && (
                <>
                  <div>
                    <span
                      className="fa fa-pencil cursor-pointer"
                      onClick={() => {
                        setAccordionState({
                          ...accordionState,
                          accordion1: {
                            ...accordionState?.accordion1,
                            close: false,
                            edit: false,
                            visited: false,
                          },
                          accordion2: {
                            ...accordionState?.accordion2,
                            close: true,
                            edit: false,
                            visited: false,
                          },
                          accordion3: {
                            ...accordionState?.accordion3,
                            close: true,
                            edit: false,
                            visited: false,
                          },
                          accordion4: {
                            ...accordionState?.accordion4,
                            close: true,
                            edit: false,
                            visited: false,
                          },
                        });
                      }}
                    ></span>
                  </div>
                </>
              )}
            </div>
          </div>
        </h2>
        {accordionState?.accordion1?.edit ? (
          <>
            <div className="container">
              <p className="edit-buyer-text">
                Buyer's information on legal document will be:
              </p>
              <div className="row">
                <div className="col-6">
                  <p className="edit-buyer-data">Buyer :-</p>
                  <p className="edit-buyer-data mb-0">{buyer?.company || ""}</p>
                  <p className="edit-buyer-data mb-0">
                    {buyer?.firstName} {buyer?.lastName}
                  </p>
                  <p className="edit-buyer-data">{buyer?.email}</p>
                </div>
                {(cobuyerDetails?.firstName ||
                  cobuyerDetails?.lastName ||
                  cobuyerDetails?.email) && (
                  <div className="col-6">
                    <p className="edit-buyer-data">Co-Buyer :-</p>
                    <p className="edit-buyer-data mb-0">
                      {cobuyerDetails?.company || ""}
                    </p>
                    <p className="edit-buyer-data mb-0">
                      {cobuyerDetails?.firstName} {cobuyerDetails?.lastName}
                    </p>
                    <p className="edit-buyer-data">{cobuyerDetails?.email}</p>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <div
            id="flush-collapseTwo"
            className={`accordion-collapse collapse ${
              accordionState?.accordion1?.close ? "" : "show"
            }`}
            aria-labelledby="flush-headingTwo"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="purchasefor">
                <p className="mb-0 pt-1 purchase-for-ui">
                  The purchase is being made on behalf of:
                </p>
                <div className="values">
                  <div className="form-check form-check-inline fs-12">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="purchaseOnBehalfIndividual"
                      id="purchaseforIndividual"
                      value="true"
                      checked={purchaseforIndividual === "true" ? true : false}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="purchaseforIndividual"
                    >
                      Individual
                    </label>
                  </div>
                  <div className="form-check form-check-inline fs-12">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="purchaseOnBehalfIndividual"
                      id="purchaseforBusiness"
                      value="false"
                      onChange={handleChange}
                      checked={purchaseforIndividual === "false" ? true : false}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="purchaseforBusiness"
                    >
                      Business
                    </label>
                  </div>
                </div>
              </div>
              <div className="buyer-form">
                {purchaseforIndividual === "true" ? (
                  <DynamicForm
                    fieldsConfig={buyerFields}
                    setCifFormDetails={setBuyer}
                    cifFormetails={buyer}
                    // preFilledEmail={
                    //   profileDetails?.userDetails?.emailId ? true : false
                    // }
                    preFilledEmail={false}
                    setHaveErrors={setHaveErrors}
                    statePrefilled={null}
                    registerValidationTrigger={(fn) =>
                      (validationFnRef.current.buyer = fn)
                    }
                    validateAgentEmail={validateEmail}
                    externalErrors={externalFormErrors}
                    setExternalFormErrors={setExternalFormErrors}
                  />
                ) : (
                  <>
                    <DynamicForm
                      fieldsConfig={businessFileds}
                      setCifFormDetails={setBuyer}
                      cifFormetails={buyer}
                      setHaveErrors={setHaveErrors}
                      preFilledEmail={false}
                      statePrefilled={null}
                      registerValidationTrigger={(fn) =>
                        (validationFnRef.current.buyer = fn)
                      }
                      externalErrors={externalFormErrors}
                      setExternalFormErrors={setExternalFormErrors}
                    />
                    {(llc === "Required" || llc === "Optional") && (
                      <div className="upload-document-section mt-3">
                        <p className="fs-12">
                          Please upload Business Entity formation documents here
                          (E.g.: LLC - Certificate of Formation, Corporation -
                          Articles of Incorporation, LP - Certificate of Limited
                          Partnership, etc.){" "}
                          {llc === "Required" && (
                            <span className="mandatory"> *</span>
                          )}
                        </p>
                        <>
                          <input
                            type="file"
                            name="llc-upload"
                            id="llc-upload"
                            required={llc === "Required"}
                            onChange={(e) =>
                              handleFileUpload(e, "businessEntityDocs")
                            }
                            accept=".pdf,.jpg,.jpeg"
                            // className="form-control m-3 w-50"
                            className="d-none"
                          />
                          <label
                            htmlFor="llc-upload"
                            className="llc-upload-btn"
                          >
                            Upload Business Entity Formation Documents
                          </label>
                          <div
                            className="cursor-pointer d-inline-block mb-0 info-tooltip-offer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="If a legal entity is purchasing the property, please upload the formation documents for that entity stamped as filed with the relevant state agency (typically the office of the Secretary of State where the entity was formed). Examples of acceptable documents include stamped copies of: the Articles of Incorporation of a corporation, Certificate of Formation for a LLC, Certificate of Limited Partnership for a LP."
                          >
                            i
                          </div>
                        </>
                        <p className="info-uploaf">
                          File formats accepted: pdf, jpg and jpeg. Maximum file
                          size allowed is 10MB.
                        </p>
                        {documentLoading && (
                          <ShimmerText line={2} gap={10} className="mt-2" />
                        )}
                        {uploadedFiles.businessEntityDocs?.length > 0 && (
                          <>
                            {uploadedFiles?.businessEntityDocs?.map((data) => (
                              <>
                                <div className="uploaded-file-container p-2">
                                  <div className="file-info d-flex align-items-center">
                                    <img
                                      src="/assets/images/downloadIconOffer.png"
                                      height={"14px"}
                                      width={"14px"}
                                      className=""
                                      onClick={() =>
                                        handleFileDownload(
                                          data.documentId,
                                          data.fileName
                                        )
                                      }
                                    />
                                    <span className="fs-12 filename-offer">
                                      {data.fileName}
                                    </span>
                                    <button
                                      className="btn-delete-offer-file"
                                      onClick={() =>
                                        handleFileDelete(
                                          "businessEntityDocs",
                                          data.documentId
                                        )
                                      }
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </>
                            ))}
                          </>
                        )}
                        {fileErrors["llc-upload"]?.length > 0 && (
                          <div className={`error-message-offer `}>
                            {fileErrors["llc-upload"]}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
                <div className="co-buyer p-3">
                  <div className="cobuyer-selection">
                    <div className="d-flex g-5 justify-content-start">
                      <p className="purchase-for-ui  mb-4 pt-1 mr90">
                        Do you have a co-buyer?
                      </p>
                      <div className="values">
                        <div className="form-check form-check-inline fs-12">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="cobuyer"
                            id="cobuyer-yes"
                            value="true"
                            onChange={handleChange}
                            checked={cobuyer === "true" ? true : false}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cobuyer-yes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check form-check-inline fs-12">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="cobuyer"
                            id="cobuyer-no"
                            value="false"
                            onChange={handleChange}
                            checked={cobuyer === "false" ? true : false}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cobuyer-no"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    {cobuyer === "true" && (
                      <>
                        <div className="d-flex fs-12">
                          <p className="purchase-for-ui  mb-4 pt-1 mr41">
                            Is the co-buyer a business entity?
                          </p>
                          <div className="values">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="cobuyerBusiness"
                                id="cobuyer-yes"
                                value="true"
                                onChange={handleChange}
                                checked={
                                  isCoBuyerBusiness === "true" ? true : false
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="cobuyer-yes"
                              >
                                Yes
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="cobuyerBusiness"
                                id="cobuyer-no"
                                value="false"
                                onChange={handleChange}
                                checked={
                                  isCoBuyerBusiness === "false" ? true : false
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="cobuyer-no"
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        {isCoBuyerBusiness === "false" ? (
                          <DynamicForm
                            fieldsConfig={buyerFields}
                            setCifFormDetails={setCobuyerDetails}
                            cifFormetails={cobuyerDetails}
                            setHaveErrors={setHaveErrors}
                            preFilledEmail={false}
                            statePrefilled={null}
                            registerValidationTrigger={(fn) =>
                              (validationFnRef.current.coBuyer = fn)
                            }
                            externalErrors={externalFormErrorsCo}
                            setExternalFormErrors={setExternalFormErrorsCo}
                            validateCobuyerEmail={buyer?.email}
                          />
                        ) : (
                          <>
                            <DynamicForm
                              fieldsConfig={businessFileds}
                              setCifFormDetails={setCobuyerDetails}
                              cifFormetails={cobuyerDetails}
                              setHaveErrors={setHaveErrors}
                              preFilledEmail={false}
                              statePrefilled={null}
                              registerValidationTrigger={(fn) =>
                                (validationFnRef.current.coBuyer = fn)
                              }
                              externalErrors={externalFormErrorsCo}
                              setExternalFormErrors={setExternalFormErrorsCo}
                              validateCobuyerEmail={buyer?.email}
                            />
                            {(llc === "Required" || llc === "Optional") && (
                              <div className="upload-document-section mt-3">
                                <p className="fs-12">
                                  Please upload Business Entity formation
                                  documents here (E.g.: LLC - Certificate of
                                  Formation, Corporation - Articles of
                                  Incorporation, LP - Certificate of Limited
                                  Partnership, etc.)
                                </p>
                                <>
                                  <input
                                    type="file"
                                    name="co-buyerllc"
                                    id="co-buyerllc"
                                    required={llc === "Required" ? true : false}
                                    onChange={(e) =>
                                      handleFileUpload(e, "coBuyerBusinessDocs")
                                    }
                                    accept=".pdf,.jpg,.jpeg"
                                    className="d-none"
                                  />
                                  <label
                                    htmlFor="co-buyerllc"
                                    className="llc-upload-btn"
                                  >
                                    Upload Business Entity Formation Documents
                                  </label>
                                  <div
                                    className="cursor-pointer d-inline-block mb-0 info-tooltip-offer"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="If a legal entity is purchasing the property, please upload the formation documents for that entity stamped as filed with the relevant state agency (typically the office of the Secretary of State where the entity was formed). Examples of acceptable documents include stamped copies of: the Articles of Incorporation of a corporation, Certificate of Formation for a LLC, Certificate of Limited Partnership for a LP."
                                  >
                                    i
                                  </div>
                                </>
                                <p className="info-uploaf">
                                  File formats accepted: pdf, jpg and jpeg.
                                  Maximum file size allowed is 10MB.
                                </p>

                                {documentLoading && (
                                  <ShimmerText
                                    line={2}
                                    gap={10}
                                    className="mt-2"
                                  />
                                )}
                                {uploadedFiles.coBuyerBusinessDocs?.length >
                                  0 && (
                                  <>
                                    {uploadedFiles?.coBuyerBusinessDocs?.map(
                                      (data) => (
                                        <>
                                          <div className="uploaded-file-container p-2">
                                            <div className="file-info d-flex align-items-center">
                                              <img
                                                src="/assets/images/downloadIconOffer.png"
                                                height={"14px"}
                                                width={"14px"}
                                                className=""
                                                onClick={() =>
                                                  handleFileDownload(
                                                    data.documentId,
                                                    data.fileName
                                                  )
                                                }
                                              />
                                              <span className="fs-12 filename-offer">
                                                {data.fileName}
                                              </span>
                                              <button
                                                className="btn-delete-offer-file"
                                                onClick={() =>
                                                  handleFileDelete(
                                                    "coBuyerBusinessDocs",
                                                    data.documentId
                                                  )
                                                }
                                              >
                                                Delete
                                              </button>
                                            </div>
                                          </div>
                                        </>
                                      )
                                    )}
                                  </>
                                )}

                                {fileErrors["co-buyerllc"] && (
                                  <div className={`error-message-offer `}>
                                    {fileErrors["co-buyerllc"]}
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className="continue-button mt-3 ml10"
                onClick={submitData}
                disabled={loading}
              >
                {loading ? "Continue..." : "Continue"}
              </button>
            </div>
          </div>
        )}
      </div>

      <ContinueConfirmationModal
        continueToAgent={continueToAgent}
        handleClose={handleClose}
        show={show}
        type={"buyer"}
      />
    </>
  );
};

export default EditBuyer;
